import React from "react";
export default  function SquareBox({ text, value, Icon, className, iconContainerStyle, iconStyle }) {
    return <div className={className}>
        <div className="flex items-center justify-between">
            <div className="flex-shrink pr-4">
                <div className={iconContainerStyle}>
                    <Icon className={iconStyle} />
                </div>
            </div>
            <div className="flex-1 text-center">
                <h5 className="font-bold uppercase text-md text-gray-600">
                    {text}
                </h5>
                <h3 className="font-bold text-3xl">
                    {value}
                </h3>
            </div>
        </div>
    </div>;
}


